import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {Details} from '@wix/ambassador-table-reservations-v1-reservation/types'
import {zonedTimeToUtc} from '@wix/table-reservations-lib/timezone'

import {reservationsService} from '../../../services/reservationsService'
import {goToReservationDetails} from '../../../utils/navigation'
import {RequestStatus} from '../../../utils/wrapRequest'
import {TransactionNames} from '../../../utils/constants'

export const handleReservationData = (flowAPI: ControllerFlowAPI) => {
  return async ({
    details,
    timeZone,
    experienceId,
  }: {
    details: Details
    timeZone: string | null
    experienceId: string
  }) => {
    const reservationDetails = {
      ...details,
      startDate: zonedTimeToUtc(details.startDate!, timeZone),
      experienceId,
    }

    const handleReservationTransaction = flowAPI.panoramaClient.transaction(
      TransactionNames.handleExperienceReservation,
    )

    handleReservationTransaction.start({
      params: {
        isManualApproval: false,
        reservationDetails,
      },
    })

    const setProps = flowAPI.controllerConfig.setProps
    const {getResolvedError} = flowAPI.errorHandler

    try {
      setProps({
        handleReservationDataStatus: RequestStatus.LOADING,
        handleReservationDataError: undefined,
      })

      const data = await reservationsService.holdReservation(flowAPI, reservationDetails)

      await goToReservationDetails({
        flowAPI,
        reservationId: data?.id,
      })
    } catch (err: any) {
      flowAPI.panoramaClient.errorMonitor().reportError(err)

      const resolvedError = getResolvedError(err)
      if (resolvedError.applicationError?.code !== 'TIME_NOT_AVAILABLE') {
        resolvedError.message = flowAPI.translations.t(
          'uou-reservations.reservations.not-accepting-contact-by-phone',
        )
      }
      setProps({
        handleReservationDataStatus: RequestStatus.FAILED,
        handleReservationDataError: resolvedError,
      })
    }

    handleReservationTransaction.finish()
  }
}
